import {
  Avatar, Box, MenuButton, Text,
} from '@chakra-ui/react';

export function Profile({ displayName, email, avatarSrc }: { displayName?: string | null, email?: string | null, avatarSrc?: string | null | Uint8Array }): JSX.Element {
  const imageSrc = avatarSrc?.constructor === Uint8Array ? `data:image/png;base64, ${avatarSrc}` : avatarSrc;

  return (
    <MenuButton width='fit-content' height='65px' borderRadius='66px' backgroundColor='white' boxShadow='0px 25px 70px rgba(125, 125, 125, 0.45)'>
      <Box display='flex' flexDir='row' justifyContent='space-between' alignItems='center' width='100%' paddingRight='23px' paddingLeft='9px'>
        <Avatar name={displayName ?? undefined} src={imageSrc ? `${imageSrc}` : ''} boxSize='46px' />
        <Box display='flex' fontWeight='500' flexDir='column' flexGrow={1} paddingLeft='15px'>
          <Text alignSelf='flex-start' fontSize='15px' lineHeight='18px'>{displayName}</Text>
          <Text
            alignSelf='flex-start'
            as='p'
            fontSize='12px'
            lineHeight='14px'
            color='gray.500'
            display={['none', 'none', 'none', 'inline-block']}
          >{email}
          </Text>
        </Box>
      </Box>
    </MenuButton>
  );
}
